import React from "react";
import Container from "./Container";
import DownloadLogo from "../assets/images/download.svg";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import Watermark from "../assets/images/Watermark.png";
import Logo from "../assets/images/Logo.png";
import TableWithStickyHeader from "./TableWithStickyHeader";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import useLocale from "../../src/locales/index";
import html2pdf from "html2pdf.js";

const Table = ({ activeTab }) => {
  const { investmentDataSIP, noOfInvestementYear, filterInvestmentData } =
    useSelector((state) => (activeTab === 0 ? state.sip : state.lum));
  const cAccept = localStorage.getItem("grow-cookies");
  const cookieAccept = JSON.parse(cAccept);
  const { textData } = useLocale();

  const hData = localStorage.getItem("historyData");

  const historyData = hData ? JSON.parse(hData) : [];

  const generatePDF = () => {
    // Function to chunk data into pages
    const chunkData = (array, size) => {
      const chunked = [];
      for (let i = 0; i < array.length; i += size) {
        chunked.push(array.slice(i, i + size));
      }
      return chunked;
    };

    // Get display data based on the same logic as original
    const getDisplayData = () => {
      if (investmentDataSIP?.length === 0) {
        return historyData || [];
      } else if (noOfInvestementYear === "") {
        return [];
      } else {
        return (
          (filterInvestmentData?.length > 0 && filterInvestmentData) ||
          investmentDataSIP ||
          []
        );
      }
    };

    const displayData = getDisplayData();
    const itemsPerPage = 26;

    // If no data, don't generate PDF
    if (displayData.length === 0) {
      return;
    }

    // Determine report title
    const reportTitle =
      activeTab === 0 || activeTab === 1
        ? "Overall Investment Report"
        : historyData?.[0]?.tabName === "sipCalc"
        ? `${textData.filterDropDown.sipCalc} ${textData.report}`
        : `${textData.filterDropDown.lumpsumCalc} ${textData.report}`;

    // Determine headers based on tab
    const currentHeaders =
      activeTab === 1 ||
      (historyData && historyData[0]?.tabName === "lumpsumCalc")
        ? headerLum
        : headers;

    const dataChunks = chunkData(displayData, itemsPerPage);
    const totalPages = dataChunks.length;

    const allContent = document.createElement("div");

    dataChunks.forEach((pageData, pageIndex) => {
      const pageNumber = pageIndex + 1;

      const pageContent = `
  <section style="position: relative; width: 100%; height: 287mm; flex: 1; margin-top: 0px; padding-bottom: 10px; page-break-after: ${
    pageIndex < totalPages - 1 ? "always" : "auto"
  }; display: flex; flex-direction: column; background-color: #ffffff;">
          
          <!-- Watermark - Behind content -->
          <img src="${Watermark}" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 1; width: 400px; height: auto; z-index: 99;" />
          
          <!-- Content Container - Above watermark -->
          <div style="position: relative; z-index: 2; display: flex; flex-direction: column; height: 100%; background-color: transparent;">
            
            <!-- Header -->
            ${
              pageIndex === 0
                ? `<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                    <img src="${Logo}" alt="logo" style="width: 60px; height: auto;" />
                    <h2 style="text-align: center; font-size: 20px; font-weight: 500; margin: 0; color: #000; font-family: 'Noto Sans Devanagari', sans-serif;">${reportTitle}</h2>
                    <div style="width: 60px;"></div>
                  </div>`
                : `<div style="height: 30px;"></div>`
            }
              
              <!-- Table Container -->
              <div style="margin-top: 10px;">
                <div style="overflow-x: auto; background-color: #ffffff;">
                  <table style="width: 100%; border-collapse: collapse; background-color: #ffffff;">
                    <thead>
                      <tr style="font-size: 13px; background-color: white;">
                        ${currentHeaders
                          .map((header, index) => {
                            // Handle dynamic header for third column
                            let displayHeader = header;
                            if (index === 2) {
                              if (activeTab === 1) {
                                displayHeader =
                                  textData.tableLabels.initialInvestment;
                              } else if (
                                historyData &&
                                historyData[0]?.tabName === "lumpsumCalc"
                              ) {
                                displayHeader =
                                  textData.tableLabels.initialInvestment;
                              }
                            }
                            return `<th style="padding: 4px 4px 6px 4px; text-align: start; vertical-align: middle; border: 1px solid #d1d5db; font-size: 13px; font-weight: 600; color: #000; background-color: white;">${displayHeader}</th>`;
                          })
                          .join("")}
                      </tr>
                    </thead>
                    <tbody>
                      ${pageData
                        .map(
                          (item, index) => `
                        <tr style="background-color: ${
                          index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                        };">
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.age || "-"
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.year || "-"
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.monthlyInvestment === 0 ||
                            item?.monthlyInvestment === ""
                              ? "-"
                              : FormatIndianNumber(item?.monthlyInvestment)
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.investmentAmounts === 0
                              ? "-"
                              : FormatIndianNumber(item?.investmentAmounts)
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.yearlyInvestment === 0 ||
                            item?.yearlyInvestment === ""
                              ? "-"
                              : FormatIndianNumber(item?.yearlyInvestment)
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.yearlyReturn === 0 ||
                            item?.yearlyReturn === ""
                              ? "-"
                              : FormatIndianNumber(item?.yearlyReturn)
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.swpAmount === 0
                              ? "-"
                              : FormatIndianNumber(item?.swpAmount)
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.yearlyReturnAfterSWP === 0
                              ? "-"
                              : FormatIndianNumber(item?.yearlyReturnAfterSWP)
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.monthlyReturn === 0
                              ? "-"
                              : FormatIndianNumber(item?.monthlyReturn)
                          }</td>
                          <td style="padding: 6px; border: 1px solid #d1d5db; text-align: start; vertical-align: middle; font-size: 13px; color: #000; background-color: inherit;">${
                            item?.ltcgAmount === 0 || item?.ltcgAmount === ""
                              ? "-"
                              : FormatIndianNumber(item?.ltcgAmount)
                          }</td>
                        </tr>
                      `
                        )
                        .join("")}
                    </tbody>
                  </table>
                </div>
              </div>         
            ${
              pageIndex === totalPages - 1
                ? `
              <!-- Disclaimer Section -->
              <div style="margin-top: 30px; background-color: #ffffff; padding: 10px 0;">
                <h3 style="font-size: 18px; font-weight: 600; margin-bottom: 10px; text-align: start; margin-top: 0px; color: #000; padding: 0;">${textData.netWorthContent.descaimber}:</h3>
                <p style="font-size: 12px; text-align: justify; color: #000; line-height: 1.4; margin: 0;">${textData.footerdescription}</p>
              </div>
            `
                : ""
            }
          </div>
          
          <!-- Spacer to push footer to bottom -->
          <div style="flex-grow: 1;"></div>
  
          <!-- Footer - Always at bottom -->
          <div style="display: flex; justify-content: space-between; align-items: center; font-size: 11px; color: #6b7280; padding-top: 20px; margin-top: auto; background-color: #ffffff; z-index: 2; position: relative;">
            <span style="font-weight: 700; color: #000; font-family: 'Times New Roman', Times, serif; font-size: 13px;">Page ${pageNumber}</span>
            <a href="https://growlifefund.com" style="text-decoration: underline; color: #000; font-size: 13px; font-weight: 700; line-height: 1.5; font-family: 'Times New Roman', Times, serif;">www.growlifefund.com</a>
          </div>
        </section>
      `;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = pageContent;
      allContent.appendChild(tempDiv.firstElementChild);
    });

    // Add the content to the document body temporarily
    document.body.appendChild(allContent);

    // Configure html2pdf options
    const options = {
      margin: [3, 10, 3, 10],
      filename: `investment_report_${new Date()
        .toLocaleDateString()
        .replace(/\//g, "-")}.pdf`,
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        logging: false,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
      },
      pagebreak: {
        mode: ["avoid-all", "css", "legacy"],
      },
    };

    // Generate and save PDF
    html2pdf()
      .from(allContent)
      .set(options)
      .save()
      .then(() => {
        // Clean up
        document.body.removeChild(allContent);

        // Log analytics if cookies accepted
        if (cookieAccept && analytics) {
          logEvent(analytics, "download_report", {
            report_type: reportTitle,
            total_pages: totalPages,
            total_records: displayData.length,
          });
        }
      })
      .catch((error) => {
        console.error("PDF generation failed:", error);
        document.body.removeChild(allContent);
      });
  };

  const headers = [
    textData.tableLabels.age,
    textData.tableLabels.year,
    `${textData.tableLabels.monthlyInvestment} (${textData.currency}) `,
    `${textData.tableLabels.additionalInvestment} (${textData.currency}) `,
    `${textData.tableLabels.totalInvestment} (${textData.currency}) `,
    `${textData.tableLabels.yearlyReturn} (${textData.currency}) `,
    `${textData.tableLabels.swpAmount} (${textData.currency}) `,
    `${textData.tableLabels.returnAfterSWP} (${textData.currency}) `,
    `${textData.tableLabels.monthlyReturn} (${textData.currency}) `,
    `${textData.tableLabels.ltcgAmount} (${textData.currency}) `,
  ];

  const headerLum = [
    textData.tableLabels.age,
    textData.tableLabels.year,
    `${textData.tableLabels.initialInvestment} (${textData.currency})`,
    `${textData.tableLabels.additionalInvestment} (${textData.currency})`,
    `${textData.tableLabels.totalInvestment} (${textData.currency})`,
    `${textData.tableLabels.yearlyReturn} (${textData.currency})`,
    `${textData.tableLabels.swpAmount} (${textData.currency})`,
    `${textData.tableLabels.returnAfterSWP} (${textData.currency})`,
    `${textData.tableLabels.monthlyReturn} (${textData.currency})`,
    `${textData.tableLabels.ltcgAmount} (${textData.currency})`,
  ];

  const getDisplayData = () => {
    if (investmentDataSIP?.length === 0) {
      // Render historyData when investmentDataSIP is empty
      return historyData || [];
    } else if (noOfInvestementYear === "") {
      return [];
    } else {
      // Use filterInvestmentData if available, otherwise investmentDataSIP
      return (
        (filterInvestmentData?.length > 0 && filterInvestmentData) ||
        investmentDataSIP ||
        []
      );
    }
  };
  const isLumpsumContext = () => {
    return (
      activeTab === 1 ||
      (historyData && historyData[0]?.tabName === "lumpsumCalc")
    );
  };
  const displayData = getDisplayData();
  const isNoData = displayData.length === 0 || noOfInvestementYear === "";
  const activeTabName = historyData[0]?.tabName;

  const selectedHeaders = activeTabName === "sipCalc" ? headers : headerLum;

  return (
    <Container>
      <div
        className={`flex justify-between items-center  px-[0px]`}
        id="tableScroll"
      >
        <div className="sm:text-[18px] text-[15px] text-black font-lato-semibold-600 text-left">
          {activeTab === 0 || activeTab === 1
            ? "Overall Investment Report"
            : historyData?.[0]?.tabName === "sipCalc"
            ? `${textData.filterDropDown.sipCalc} ${textData.report}`
            : `${textData.filterDropDown.lumpsumCalc} ${textData.report}`}
        </div>
        <div className="group relative">
          <button
            onClick={() => {
              generatePDF();
              if (cookieAccept && analytics) {
                logEvent(analytics, "download_report");
              }
            }}
          >
            <img
              src={DownloadLogo}
              alt="Download-Icon"
              className="sm:w-auto sm:h-auto w-[24px] h-[24px]"
            />
          </button>
          <span className="absolute hidden font-lato-regular-400 group-hover:flex justify-center -left-[65px] -top-2 -translate-y-full w-[100px]  m-auto px-1 py-1 bg-gray rounded-lg text-center text-white text-[12px] after:content-[''] after:absolute after:left-[80%] after:top-[100%] after:-translate-x-1/2 after:border-8 after:border-x-[transparent] after:border-b-[transparent] after:border-t-gray">
            {textData.historyData.downoadPDF}
          </span>
        </div>
      </div>
      <div
        className={`overflow-x-auto  mt-[25px] rounded-[8px] border border-[#0752B533] px-0 `}
      >
        <TableWithStickyHeader
          id="table-to-download"
          className="min-w-full border border-[#0752B533]  overflow-hidden border-separate border-spacing-0 custom-table"
        >
          <thead className="bg-[#ffffff] text-left">
            <tr>
              {selectedHeaders?.map((header, index, array) => (
                <th
                  key={index}
                  scope="col"
                  className={`px-[12px]  sm:text-[15px] text-[14px] py-[14px] text-black font-medium ${
                    index !== array?.length - 1 ? "border-r" : "border-r"
                  } border-b border-[#0752B533]`}
                >
                  {(activeTab === 1 && index === 2) ||
                  (historyData &&
                    historyData[0]?.tabName === "lumpsumCalc" &&
                    index === 2)
                    ? `${textData.tableLabels.initialInvestment} (${textData.currency})`
                    : header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white text-left">
            {investmentDataSIP?.length === 0 ? (
              // Render historyData when investmentDataSIP is empty
              historyData ? (
                historyData?.map((item, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-[#F6F8FB]" : "bg-white"
                    } `}
                  >
                    <td
                      key={index}
                      className={`px-[12px] py-[14px] whitespace-nowrap
                    sm:text-[15px] text-[14px] text-gray border-r
                     border-[#0752B533] ${
                       index === historyData?.length - 1 ? "" : "border-b"
                     }`}
                    >
                      {item?.age}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r  ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533]`}
                    >
                      {item?.year}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r  ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533]`}
                    >
                      {isLumpsumContext()
                        ? "-"
                        : item?.monthlyInvestment === 0 ||
                          item.monthlyInvestment == ""
                        ? "-"
                        : FormatIndianNumber(item?.monthlyInvestment)}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r  ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533]`}
                    >
                      {item?.investmentAmounts === 0
                        ? "-"
                        : FormatIndianNumber(item?.investmentAmounts)}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r  ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533]`}
                    >
                      {item?.yearlyInvestment === 0 ||
                      item.yearlyInvestment == ""
                        ? "-"
                        : FormatIndianNumber(item?.yearlyInvestment)}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r  ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533]`}
                    >
                      {item?.yearlyReturn === 0 || item.yearlyReturn == ""
                        ? "-"
                        : FormatIndianNumber(item?.yearlyReturn)}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r  ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533]`}
                    >
                      {item?.swpAmount === 0
                        ? "-"
                        : FormatIndianNumber(item?.swpAmount)}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r  ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533]`}
                    >
                      {/* {yearlyWithdraw === " "
                        ? "-"
                        : item?.yearlyReturnAfterSWP == 0
                        ? "-"
                        : FormatIndianNumber(item?.yearlyReturnAfterSWP)} */}
                      {item?.yearlyReturnAfterSWP == 0
                        ? "-"
                        : FormatIndianNumber(item?.yearlyReturnAfterSWP)}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-gray border-r ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533] text-[14px] text-gray`}
                    >
                      {item?.monthlyReturn === 0
                        ? "-"
                        : FormatIndianNumber(item?.monthlyReturn)}
                    </td>
                    <td
                      className={`px-[12px] py-[14px] sm:text-[15px] text-gray border-r ${
                        index === historyData?.length - 1 ? "" : "border-b"
                      } border-[#0752B533] text-[14px] text-gray`}
                    >
                      {item?.ltcgAmount === 0 || item?.ltcgAmount === ""
                        ? "-"
                        : FormatIndianNumber(item?.ltcgAmount)}
                    </td>
                  </tr>
                ))
              ) : (
                // Render a single row with "Data not availble" message if historyData is empty
                <tr>
                  <td
                    colSpan="10"
                    className={`px-[12px] py-[14px] whitespace-nowrap sm:text-[20px] text-center text-[14px] text-black font-lato-regular-400`}
                  >
                    {textData.historyData.dataNotAvailable}
                  </td>
                </tr>
              )
            ) : noOfInvestementYear === "" ? (
              <tr>
                <td
                  colSpan="10"
                  className={`px-[12px] py-[14px] whitespace-nowrap sm:text-[20px] text-center text-[14px] text-black font-lato-regular-400`}
                >
                  {textData.historyData.dataNotAvailable}
                </td>
              </tr>
            ) : (
              historyData.map((item, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-[#F6F8FB]" : "bg-white"
                  } `}
                >
                  <td
                    key={index}
                    className={`px-[12px] py-[14px] whitespace-nowrap
                    sm:text-[15px] text-[14px] text-gray border-r
                     border-[#0752B533] ${
                       index === filterInvestmentData?.length - 1 ||
                       index === investmentDataSIP?.length - 1
                         ? ""
                         : "border-b"
                     } `}
                  >
                    {item?.age}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r border-[#0752B533] ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    }`}
                  >
                    {item?.year}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r border-[#0752B533] ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    }`}
                  >
                    {isLumpsumContext()
                      ? "-"
                      : item?.monthlyInvestment === 0 ||
                        item.monthlyInvestment == ""
                      ? "-"
                      : FormatIndianNumber(item?.monthlyInvestment)}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r border-[#0752B533] ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    }`}
                  >
                    {item?.investmentAmounts === 0
                      ? "-"
                      : FormatIndianNumber(item?.investmentAmounts)}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r border-[#0752B533] ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    }`}
                  >
                    {item?.yearlyInvestment === 0 ||
                    item?.yearlyInvestment === ""
                      ? "-"
                      : FormatIndianNumber(item?.yearlyInvestment)}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r border-[#0752B533] ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    }`}
                  >
                    {item?.yearlyReturn === 0
                      ? "-"
                      : FormatIndianNumber(item?.yearlyReturn)}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r border-[#0752B533] ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    }`}
                  >
                    {item?.swpAmount === 0
                      ? "-"
                      : FormatIndianNumber(item?.swpAmount)}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] text-gray border-r border-[#0752B533] ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    }`}
                  >
                    {/* {yearlyWithdraw == ""
                      ? "- "
                      : item?.yearlyReturnAfterSWP == 0
                      ? "-"
                      : FormatIndianNumber(item?.yearlyReturnAfterSWP)} */}
                    {item?.yearlyReturnAfterSWP == 0
                      ? "-"
                      : FormatIndianNumber(item?.yearlyReturnAfterSWP)}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] border-r border-[#0752B533]  text-gray ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    } `}
                  >
                    {item?.monthlyReturn === 0
                      ? "-"
                      : FormatIndianNumber(item?.monthlyReturn)}
                  </td>
                  <td
                    className={`px-[12px] py-[14px] sm:text-[15px] text-[14px] border-[#0752B533]  text-gray ${
                      index === filterInvestmentData?.length - 1 ||
                      index === investmentDataSIP?.length - 1
                        ? ""
                        : "border-b"
                    } `}
                  >
                    {item?.ltcgAmount === 0 || item?.ltcgAmount === ""
                      ? "-"
                      : FormatIndianNumber(item?.ltcgAmount)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </TableWithStickyHeader>
      </div>
    </Container>
  );
};

export default Table;
